import * as React from 'react'
import * as ReactDOM from 'react-dom'
import {CallJs} from "../../lib/types";
import {CSSProperties} from "react";
import {mapObjectKeys} from "../../lib/utils";
import {AjaxRequest} from "../../lib/ajax";

const StandardButtons = (params: RegistrationsUIParams) =>
	<tr>
		<td colSpan={7} style={{textAlign: "center"}}>
			<button
				type="button"
				className="submit"
				style={{width: "auto"}}
				onClick={() => new_window_resizable(params.nameTagsLink, 800, 600)}
				disabled={params.nameTagsDisabled}>
				Print Name Tags
			</button>

			&emsp;

			<button
				type="button"
				className="submit"
				style={{width: "auto"}}
				onClick={() => new_window_resizable(params.nameTagsSpeakerLink, 800, 600)}
				disabled={params.nameTagsSpeakerDisabled}>
				Print Speaker Name Tags
			</button>
			&emsp;
			<button
				type="button"
				className="submit"
				style={{width: "auto" }}
				onClick={() => new_window_resizable(params.seatingLink, 800, 600)}
				disabled={params.seatingDisabled}>
				Print Seating
			</button>
			&emsp;
			<button
				type="button"
				className="submit"
				style={{width: "auto"}}
				onClick={() => document.location.assign(params.exportLink)}>
				Export
			</button>

			{params.withETANSWExport &&

			<button
				type="button"
				className="submit"
				style={{width: "auto"}}
				onClick={() => document.location.assign(params.exportLink+"&etanswexport=1")}>
				ETANSW Export
			</button>
			}
			<br />
		</td>
	</tr>

type RegistrationUIParams =
	{type:'record', prop: StandardRegistrationUIParams, ix: string|number}
	|{type: 'group', prop: GroupRegistrationUIParams, ix: string|number}

type RegistrationsUIParams = {
	withMoodle: boolean
	records: RegistrationUIParams[]
	nameTagsLink: string
	nameTagsDisabled: boolean
	nameTagsSpeakerLink: string
	nameTagsSpeakerDisabled: boolean
	seatingLink: string
	seatingDisabled: boolean
	exportLink: string
	withETANSWExport: boolean
}

export const noRegistrationsFound: CallJs<{}> = (replace, params) => {
	const div = document.createElement('div')
	ReactDOM.render(<NoRegistrationsUI />, div)
	replace(div)
}

const NoRegistrationsUI = () =>
	<div className="form" style={{padding: '10px'}}>
		<h3 style={{textAlign:'center'}}>No Registrations Found</h3>
	</div>

export const registrations: CallJs<RegistrationsUIParams> = (replace, params) => {
	const div = document.createElement('div')
	replace(div)
	ReactDOM.render(<RegistrationsUI {...params} />, div)
}

//this comes from the HTML that is spat out by the Events2 page.
declare function new_window_resizable(url: string, width: number, height: number): void

const RegistrationsUI = (params: RegistrationsUIParams) =>
	<table className="adminlist border" cellSpacing={0}>
		<thead>
		<StandardButtons {...params} />
<tr>
	<th style={{width: "30px"}}>
		<a href="#" onClick={ () => {
							if (confirm('This action will delete the checked registrations from the event.\n\nNO MONEY WILL BE REFUNDED\n\nAre you sure you want to delete?'))
							{
								(document as any).deleteRegistrationsForm.deleteRegistrationsTrigger.value = '1';
								(document as any).deleteRegistrationsForm.submit();
							}}}>
			<img src="/sb/static/images/icons/delete.gif" width="20" height="22" />
		</a>
	</th>
	<th style={{width: "220px", textAlign: "left"}}>
		Name
	</th>
	<th style={{width: "215px"}}>
		Email
	</th>
	<th style={{width: "80px"}}>
		Status
	</th>
	<th style={{width: "70px"}}>
		Reg Date
	</th>
	<th style={{width: "55px"}}>
		Order No
	</th>
	{
		params.withMoodle &&
		<th style={{width: "55px"}}>
			Moodle
		</th>
	}
	<th style={{width: "24px"}}>
		&nbsp;
	</th>
</tr>
</thead>
		<tbody>
		{params.records.map(p => <RegistrationUI withMoodle={params.withMoodle} key={p.ix} props={p} />)}
		</tbody>
		<tfoot>
		<StandardButtons {...params} />
		</tfoot>
	</table>

const RegistrationUI = (params: {withMoodle: boolean, props: RegistrationUIParams}) => {
	switch (params.props.type) {
		case "group":
			return <GroupRegistrationUI withMoodle={params.withMoodle} {...params.props.prop}/>
		case "record":
			return <StandardRegistrationUI withMoodle={params.withMoodle} {...params.props.prop}/>

	}
}

type GroupRegistrationUIParams = {
	editGroupLink: string
	groupIdentifierText: string
	groupNumberInfo: string
	withMoodle: boolean
}

export const GroupRegistrationUI = (params: GroupRegistrationUIParams) => {
	const topBorderStyle = {borderTop: '1px solid #808040'}
	const leftBorderStyle: CSSProperties =  {borderLeft: '1px solid #808040'}
	const rightBorderStyle: CSSProperties =  {borderRight: '1px solid #808040'}

	const moodleSkip = params.withMoodle ? 1 : 0;

	return <tr>
		<th colSpan={6+moodleSkip} style={{textAlign: "left", paddingLeft: "4px", ...topBorderStyle , ...leftBorderStyle}}>
			<a href={params.editGroupLink}>
				{params.groupIdentifierText}
				{params.groupNumberInfo}
			</a>
		</th>
		<th style={{...topBorderStyle, ...rightBorderStyle}}>
			<a href={params.editGroupLink} title="Edit Group Registration">
				<img src="/sb/static/images/icons/group_edit.png" width="16" height="16" />
			</a>
		</th>
	</tr>
}

type StandardRegistrationUIParams = {
	moodleReg: boolean
	bgColor: string
	isLastInGroup: boolean
	regDetailsNote: string
	eventRegistrationFormUrl: string
	regStatus: string
	regDate: string
	regOrderSerial: string
	remoodleUrl: string
	regDetails: {
		registrationSerial: string|number ,
		registrationGroupSerial: string|number ,
		tablePriceSerial: string,
		isPending: string
		email: string
	}
}
type StandardRegistrationUIParamsR = StandardRegistrationUIParams & {withMoodle: boolean}
type StandardRegistrationUIState = {
	isHovering: boolean
	isRemoodling: boolean
	moodleReg: boolean
}

type MoodleRegResult = {
	noEmail: boolean
	noMoodle: boolean
	noMoodleCourse: boolean
	alreadyEnrolled: boolean
	couldNotConnect: boolean
	perfectSuccess: boolean
}

const allReasons: {[K in keyof MoodleRegResult]: string} = {
	alreadyEnrolled: " - they were already enrolled",
	couldNotConnect: " - we could not connect to moodle",
	noEmail: " - the user doesn't have a valid email address - please set one in Contacts",
	noMoodle: " - this site has not been connected to Moodle",
	noMoodleCourse: " - this event has not been assigned a Moodle course - please set one in the Event Details",
	perfectSuccess: "The user has been successfully enrolled in the moodle course"
}

class StandardRegistrationUI extends React.Component<StandardRegistrationUIParamsR, StandardRegistrationUIState> {
	private setHover: (newState: boolean) => void
	private remoodle: (e: React.MouseEvent<HTMLInputElement>) => void

	constructor(props:StandardRegistrationUIParamsR, context?:any) {
		super(props, context)
		this.state = {isHovering: false, isRemoodling: false, moodleReg: props.moodleReg}
		this.setHover = (state) => this.setState({isHovering: state})
		this.remoodle = async (e: React.MouseEvent<HTMLInputElement>) => {
			e.preventDefault()
			this.setState({isRemoodling: true})

			try {
				const res = await new AjaxRequest(this.props.remoodleUrl).runGet({}) as MoodleRegResult

				const failure = res.perfectSuccess
					? ""
					: "The user was not enrolled: \n"

				//hack around some filthy typescriptian lies
				const reasons =
					mapObjectKeys(res, (k: keyof MoodleRegResult)  =>
						res[k] ? (allReasons)[k] as typeof allReasons[typeof k] : false) // why can't typescript tell that? sigh
						.filter(x => x)

				alert(failure + reasons.join("\n"))

				if(res.perfectSuccess || res.alreadyEnrolled) {
					this.setState({moodleReg: true})
				}
			} catch (e) {
				alert("An error occurred while communicating with the server. Please refresh the page, and if necessary try again.")
				console.log(e)
			}
			this.setState({isRemoodling: false})
		}
	}

	render() {
		const isPending = !!Number.parseInt(this.props.regDetails.isPending)

		const bgColor = this.state.isHovering ? '#D0D0D0' : this.props.bgColor;
		const leftBorderStyle: CSSProperties = this.props.regDetails.registrationGroupSerial > 0 ? {borderLeft: '1px solid #808040'} : {};
		const rightBorderStyle: CSSProperties = this.props.regDetails.registrationGroupSerial > 0 ? {borderRight: '1px solid #808040'} : {};
		const bottomBorderStyle: CSSProperties = this.props.isLastInGroup ? {borderBottom: '1px solid #808040'} : {};
		const textStyle: CSSProperties = isPending ? {color: '#777777' } : {}

		const deleteRegistrationCheckbox = Number.parseInt(this.props.regDetails.tablePriceSerial) || isPending
			? <span>&nbsp;</span>
			: <input type="checkbox" name="deleteRegistrations[]" value={this.props.regDetails.registrationSerial} />

		return <tr style={{
			height: "25px",
			backgroundColor: bgColor
		}} onMouseOver={() => this.setHover(true)} onMouseOut={() => this.setHover(false)}>
			<td style={{textAlign: 'center', ...leftBorderStyle, ...bottomBorderStyle }}>
				{deleteRegistrationCheckbox}
			</td>
			<td style={bottomBorderStyle}>
				<a href={this.props.eventRegistrationFormUrl} style={textStyle}>
					{this.props.regDetailsNote}
				</a>
			</td>
			<td style={{textAlign: 'center', ...bottomBorderStyle, ...textStyle}}>
				{this.props.regDetails.email}&nbsp;
			</td>
			<td style={{textAlign: 'center', ...bottomBorderStyle, ...textStyle}}>
				{this.props.regStatus}
			</td>
			<td style={{textAlign: 'center', ...bottomBorderStyle, ...textStyle}}>
				{this.props.regDate}
			</td>
			<td style={{textAlign: 'center', ...bottomBorderStyle, ...textStyle}}>
				{this.props.regOrderSerial}
			</td>
			{
				this.props.withMoodle &&
				<td style={{textAlign: 'center', ...bottomBorderStyle, ...textStyle}}>
					{!isPending && (this.state.moodleReg ? "✔️" :
							<input
								onClick={this.remoodle}
								disabled={this.state.isRemoodling}
								type="image"
								height={16}
								width={16}
								src={this.state.isRemoodling
									? "/sb/static/images/loadergif.gif"
									: "/sb/static/images/icons/arrow_refresh.png"} />
					)}
				</td>
			}
			<td style={{textAlign: 'center', ...rightBorderStyle, ...bottomBorderStyle}}>
				<a href={this.props.eventRegistrationFormUrl}>
					<img src="/sb/static/images/icons/note_edit.png" width="16" height="16" />
				</a>
			</td>
		</tr>
	}
}



// WEBPACK FOOTER //
// ./src/events2/admin-event-registration-page/index.tsx